export default __webpack_public_path__ + "static/media/VersionTwoBadgeIcon.8e580c37.svg";